// **********************************************************
// Timeline Slider
// **********************************************************

const timelineMainSlider = document.querySelectorAll('[data-slider="timeline-main-slider"]');
const timelineThumbSlider = document.querySelectorAll('[data-slider="timeline-thumb-slider"]');

// *******************************************************************************
// 1.1 - Timeline Thumb Slider
// *******************************************************************************

const timelineThumbSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  watchOverflow: true,
  speed: 600,
  breakpoints: {
    767: {
      slidesPerView: 8,
    },
    1023: {
      slidesPerView: 'auto',
    },
  },
};

timelineThumbSlider.forEach((el) => new Swiper(el, timelineThumbSliderOptions));

// *******************************************************************************
// 1.2 -Timeline Main Slider
// *******************************************************************************

const timelineMainSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 0,
  speed: 600,
  effect: 'fade',
  autoHeight: true,
  fadeEffect: {
    crossFade: true,
  },
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  thumbs: {
    swiper: false,
  },
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
};

timelineMainSlider.forEach((el, i) => {
  const timelineMainSliderParent = el.closest('.timeline');

  const arrowRight = timelineMainSliderParent.querySelector('.arrow-right');
  const arrowLeft = timelineMainSliderParent.querySelector('.arrow-left');

  timelineMainSliderOptions.navigation.nextEl = arrowRight;
  timelineMainSliderOptions.navigation.prevEl = arrowLeft;

  timelineMainSliderOptions.thumbs.swiper = timelineThumbSlider[i].swiper;

  const thumbSlider = timelineThumbSlider[i].swiper;

  new Swiper(el, {
    ...timelineMainSliderOptions,
    on: {
      slideChange() {
        const activeSlideIndex = this.activeIndex;
        const thumbSlides = thumbSlider.slides;
        thumbSlides.forEach((slide, index) => {
          slide.classList.toggle('prev-slide', index < activeSlideIndex);
        });
      },
    },
  });
});
